module.exports = __webpack_public_path__ + "img/gw-popup.d2f47d20.png";